// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"47182f18","702":"a0b0106a"}[chunkId] + ".chunk.js";
};